export const MAX_INCOMING_EDGES: number = 3;
export const MAX_NODES_PER_ROW: number = 200;
export const MAX_NODES_PER_LAYER: number = MAX_NODES_PER_ROW * 2;
export const NODE_SIZE: number = 80;
export const POSITION_GAP: number = 200;
